export interface AssetBackgroundColor {
  background: string
}

/**
 * Get the asset preview background color. If "default" is passed, returns undefined.
 * @param backgroundColor string | undefined
 * @returns AssetBackgroundColor | undefined
 */
export const getAssetBackgroundColor = (backgroundColor: string | undefined): AssetBackgroundColor => {
  if (backgroundColor && backgroundColor !== 'default') {
    return {
      background: backgroundColor
    };
  }
  return undefined;
};
